import { ROLES } from "./roles";

// Lazy imports (same pattern as App.js)
import Dashboard from "../pages/dashboard/Dashboard";
import InstantRequest from "../pages/seller/InstantRequest";
import MyOffers from "../pages/seller/MyOffers";
import OfferDetails from "../pages/seller/OfferDetails";
import RequestDetails from "../pages/buyer/RequestDetails";

export const routesByRole = {

    [ROLES.SELLER]: [
        { path: "/dashboard", component: Dashboard },
        { path: "/instant-request", component: InstantRequest },
        { path: "/my-offers", component: MyOffers },
        { path: "/offer/:offerId", component: OfferDetails }
    ],

    [ROLES.BUYER]: [
        { path: "/dashboard", component: Dashboard },
        { path: "/request/:id", component: RequestDetails }
    ],

    [ROLES.FREIGHT]: [
        { path: "/dashboard", component: Dashboard }
    ],

    [ROLES.ADMIN]: [
        { path: "/dashboard", component: Dashboard }
    ]

};